import React from 'react';
/*import './Introduction.css';*/
import { useTopic } from '../../contexts/TopicContext';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import LatexDecoder from '../../utils/LatexDecoder';
const placeholderPic = require('../../assets/images/placeholder2.png')

const Introduction = () => {

    const topicData = useTopic();

    const renderDescription = () => {
        if (!topicData) {
            // Data is still loading
            return <p style={{ textIndent: 0 }}>
                <Skeleton width="100%" height={100} />
            </p>;
        }

        if (
            !topicData.description ||
            !Array.isArray(topicData.description) ||
            topicData.description.length === 0
        ) {
            // No description available
            return <div className="no-data-prompt"> No description yet </div>;
        }

        // Description exists
        return LatexDecoder(topicData.description[0].description);
    };

    return (
        <div className="row" id="introduction-container">
            <div className="col-12">
                <div id="introduction-wrapper">
                    <div className="margin-top-30 margin-btm-30 font-3 text-justify">
                        {renderDescription()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Introduction;
